( function( global, $ ) {

    function toggleActive(element) {
        global.methods.toggleAttributeValue(element, 'gr-toggle', 'active', true);
    }

    $('[gr-toggle]').on('click', function() {
        if (global.methods.hasAttributeValue($(this)[0], 'gr-toggle', 'mobile')) {
            if (global.methods.isMobile('breakpoint', 'md')) toggleActive($(this)[0]);
        } else if (global.methods.hasAttributeValue($(this)[0], 'gr-toggle', 'desktop')) {
            if (!global.methods.isMobile('breakpoint', 'md')) toggleActive($(this)[0]);
        } else {
            toggleActive($(this)[0]);
        }
    });

}( window.groots, jQuery ));
